import React, { useState } from 'react'
import { useEffect } from 'react';
import CheckSalaryRuleStep from './CheckSalaryRuleStep';
import CreateSalaryRuleStep from './CreateSalaryRuleStep';
import NextStep from './NextStep';
import { useTutorialContext } from '../TutorialProvider';

export default function Step2(props) {
  const { clientPayrollRulesGroups, payrollRulesGroup,
    clientAllowances, clientUnitPrices, values, tutorialStep2 } = props
  const { run, stepIndex, tourCompleted, type, params } = tutorialStep2
  const [loader, setLoader] = useState(false)
  const { setTutorialStep2, setTutorialStep3 } = useTutorialContext()

  useEffect(() => {
    setTimeout(() => setLoader(true), 800)
  }, [])

  return (
    <div>
      {loader &&
        <React.Fragment>
          {type == 'create' && <CreateSalaryRuleStep cookie={{ run, stepIndex, tourCompleted, type }}
            setTutorialStep2={setTutorialStep2} />
          }
          {type == 'check' && <CheckSalaryRuleStep cookie={{ run, stepIndex, tourCompleted, type, params }}
            clientPayrollRulesGroups={clientPayrollRulesGroups} clientAllowances={clientAllowances}
            payrollRulesGroup={payrollRulesGroup} clientUnitPrices={clientUnitPrices}
            values={values} setTutorialStep2={setTutorialStep2} />
          }
          {type == 'next' && tourCompleted == true && <NextStep payrollRulesGroup={payrollRulesGroup}
            setTutorialStep2={setTutorialStep2} setTutorialStep3={setTutorialStep3} />
          }
        </React.Fragment>
      }
    </div>
  )
}
